import { sustainabilityForumData } from "constants-lib/seo/sustainabilityForumData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getSustainabilityForum = () => {
  const data = sustainabilityForumData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addSustainabilityForum = () => {
  if (
    window.location.href.includes(
      `/us/en/inside-wm/sustainability-forum/together-today-for-tomorrow`,
    ) &&
    document.getElementById(`sustainabilityForum`) === null
  ) {
    const script = sustainabilityForumJSONLD()
    addJSONLDToHead(script, `sustainabilityForum`)
  } else {
    removeElement(`sustainabilityForum`)
  }
}

// JSON LD template for FAQ Bagster
const sustainabilityForumJSONLD = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getSustainabilityForum(),
  }
  return FaqBagsterTemplate
}
